import { useQuery } from '@tanstack/react-query'
import { useFetch } from './useFetch'
import { PriceTables } from 'typings/pricing'

export function usePriceTables() {
  const { fetcherWrapper } = useFetch()

  const url = new URL(`/api/proxy/pricing/tables`, window.location.origin)

  function fetcher() {
    return fetcherWrapper(url.toString()).then((r) => r.json())
  }

  return useQuery<PriceTables>({ queryKey: ['price-tables'], queryFn: fetcher })
}
